var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShareIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ShareIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.35,
    d: "M8.315 10.905a2.448 2.448 0 1 0 0 2.19m0-2.19c.165.33.258.701.258 1.095s-.093.766-.258 1.095m0-2.19 7.37-3.685m-7.37 5.875 7.37 3.685m0-9.56a2.448 2.448 0 1 0 4.379-2.19 2.448 2.448 0 0 0-4.379 2.19m0 9.56a2.44 2.44 0 0 0-.258 1.095 2.448 2.448 0 1 0 .258-1.095",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export default SvgShareIcon;